import React from 'react';

import { CarouselItem, ResponsiveCarousel } from '@lux-sandbox/carousel';
import { TabPanel } from '@lux/tabs';
import { ErrorBoundary, ArticleCompactCard } from '@browsing/components';
import { NavigationSourceType, QueryParameters } from '@browsing/utils';

import { Translate } from '@pegasus/translation';
import { ContinueShoppingCategory, ContinueShoppingCardItem } from '../types';
import { SeeAllCard } from './see-all-card';
import { CAROUSEL_BREAKPOINTS } from '../constants';
import { ArticleCardWrapper } from './styles';

interface CategoryPanelProps {
    category: ContinueShoppingCategory;
    categoriesList: ContinueShoppingCardItem[];
    shouldShowSeeAll: boolean;
    onArticleClick: (article: ContinueShoppingCardItem, index: number) => void;
    onSeeAllClick: (categoryId: number) => void;
    onScroll: () => void;
}

export const CategoryPanel: React.FC<CategoryPanelProps> = ({
    category,
    categoriesList,
    shouldShowSeeAll,
    onArticleClick,
    onSeeAllClick,
    onScroll,
}) => {
    return (
        <ErrorBoundary componentName={`continue-shopping-category-${category.categoryId}`}>
            <TabPanel id={category.categoryId.toString()}>
                <ResponsiveCarousel
                    previousSlideLabel={<Translate message="previous" raw />}
                    nextSlideLabel={<Translate message="next" raw />}
                    visibleItems={CAROUSEL_BREAKPOINTS.MOBILE}
                    visibleItemsXs={CAROUSEL_BREAKPOINTS.MOBILE_XS}
                    visibleItemsMd={CAROUSEL_BREAKPOINTS.TABLET_MD}
                    visibleItemsLg={CAROUSEL_BREAKPOINTS.DESKTOP_LG}
                    withOverflow
                    onScroll={onScroll}
                    aria-labelledby="continue-shopping-title"
                >
                    {categoriesList.map((article, index) => (
                        <CarouselItem key={article.sku}>
                            <ArticleCardWrapper>
                                <ArticleCompactCard
                                    {...article}
                                    handleOnClick={(_e: React.SyntheticEvent) => {
                                        onArticleClick(article, index);
                                    }}
                                />
                            </ArticleCardWrapper>
                        </CarouselItem>
                    ))}
                    {shouldShowSeeAll && (
                        <CarouselItem key="continue-shopping-see-all">
                            <SeeAllCard
                                href={`/articles/categories/${category.categoryId}?${QueryParameters.NavigationSource}=${NavigationSourceType.ContinueShopping}`}
                                onClick={() => onSeeAllClick(category.categoryId)}
                            />
                        </CarouselItem>
                    )}
                </ResponsiveCarousel>
            </TabPanel>
        </ErrorBoundary>
    );
};
